import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRestaurant,
  deleteRestaurant,
  downloadQRCode,
  fetchRestaurantList,
  updateRestaurant,
} from "src/services/restaurant.service";
import { toast } from "sonner";

interface FetchRestaurantListPayload {
  page: number;
  limit: number;
  search?: string;
}

interface RestaurantPayload {
  name: string;
  latitude: string;
  longitude: string;
  address: string;
}

export const doFetchRestaurantList = createAsyncThunk(
  "restaurant/fetchRestaurantList",
  async (payload: FetchRestaurantListPayload) => {
    try {
      const response = await fetchRestaurantList({
        ...payload,
        search: payload.search ?? "",
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch restaurant list";
      throw errorMessage;
    }
  }
);

export const doCreateRestaurant = createAsyncThunk(
  "restaurant/createRestaurant",
  async (data: RestaurantPayload) => {
    try {
      const response = await createRestaurant(data);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to create restaurant";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doUpdateRestaurant = createAsyncThunk(
  "restaurant/updateRestaurant",
  async ({ id, data }: { id: number; data: RestaurantPayload }) => {
    try {
      const response = await updateRestaurant(id, data);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update restaurant";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doDeleteRestaurant = createAsyncThunk(
  "restaurant/deleteRestaurant",
  async (id: number) => {
    try {
      const response = await deleteRestaurant(id);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete restaurant";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doDownloadQRCode = createAsyncThunk(
  "restaurant/downloadQRCode",
  async (rid: string) => {
    try {
      const response = await downloadQRCode(rid);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to download QR code";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
